export default __webpack_public_path__ + "static/t-shirt-821fd0d90f68afad4c032e55230d26da.jpg";